import {CopilotContextKey} from '../bootstrap/bootstrap.types';
import {CopilotContext} from '../copilot.types';

function formatContextPage(
  key: CopilotContextKey,
  pageName: string,
  prevContext: CopilotContext | null,
  currentContext: CopilotContext,
): string | null {
  const prevContextEntry = prevContext?.entries[key];
  const currentContextEntry = currentContext.entries[key];

  if (!prevContext) {
    // a fresh context => spell everything out
    if (currentContextEntry) {
      return `The user is on the ${pageName}.`;
    }

    return null;
  }

  // return only a diff

  if ((prevContextEntry && currentContextEntry) || (!prevContextEntry && !currentContextEntry)) {
    // the user was on the page and is still on the page
    // or the user wasn't on the page and still isn't on the page
    return null;
  }

  if (prevContextEntry && !currentContextEntry) {
    // the user left the page
    return `The user left the ${pageName}.`;
  }

  // post condition: the user entered the page
  return `The user entered the ${pageName}.`;
}

export default formatContextPage;
